import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useStore } from "vuex";
export default /*#__PURE__*/_defineComponent({
  props: {
    img: {
      type: String,
      required: true
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    expose();
    var store = useStore();
    /** 歌曲是否已暂停 */

    var isPause = computed(function () {
      return store.state.player.isPause;
    });
    var __returned__ = {
      store: store,
      isPause: isPause
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});